import { useEffect, useState } from "react";
import { apiRequest } from "../../utils/apiRequest";
import { showToast } from "../../utils/toastOptions";

/**
 * Shared hook for fetching data in Existing*List components
 * @param {string} url - API endpoint URL
 * @param {string|number} projectId - Project ID
 * @param {string|number} companyId - Company ID
 * @param {string|number|boolean} refreshTrigger - Trigger to refetch data
 * @param {string} errorMessage - Error message to display on failure
 * @param {object} options - Additional options for apiGet (e.g., suppressErrorToast)
 * @returns {Array} - Array containing [data, setData]
 */
export const useExistingTableData = (
  url,
  projectId,
  companyId,
  refreshTrigger,
  errorMessage = "Failed to fetch data",
  options = {}
) => {
  const [data, setData] = useState([]);

  useEffect(() => {
    if (!projectId || !companyId) return;

    const fetchData = async () => {
      try {
        const fetchedData = await apiRequest(url, { method: "GET", ...options });
        if (Array.isArray(fetchedData)) {
          setData(fetchedData);
        } else {
          setData([]);
        }
      } catch (err) {
        showToast("error", err.message || errorMessage);
        setData([]);
      }
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [projectId, companyId, refreshTrigger, url, errorMessage]);

  return [data, setData];
};
